import { createColumnHelper } from '@tanstack/react-table';
import { LocalizedDateTimeFromUtc, TruncatedText } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { Table, TableProvider, useTableState } from '@optimus-web/core';

interface Props {
    shiftId: string;
}

interface TableDataType {
    start: string;
    closed: string;
    closer: string;
    notes?: string | null;
}

const helper = createColumnHelper<TableDataType>();

const tableColumns = [
    helper.accessor('start', {
        header: () => lt('Start'),
        cell: ({ getValue }) => <LocalizedDateTimeFromUtc utcString={getValue()} />,
    }),
    helper.accessor('closed', {
        header: () => lt('Closed'),
        cell: ({ getValue }) => <LocalizedDateTimeFromUtc utcString={getValue()} />,
    }),
    helper.accessor('closer', {
        header: () => lt('Closed'),
        cell: ({ getValue }) => getValue(),
    }),
    helper.accessor('notes', {
        header: () => lt('Notes'),
        cell: ({ getValue }) => {
            const note = getValue();
            return note ? <TruncatedText text={note} maxLength={30} /> : UnicodeEntity.Dash;
        },
    }),
];

export const PastShiftDetailsTable = ({ shiftId }: Props) => {
    const { data, isLoading } = useRepositoryQuery('cashiers', 'getShift', { shiftId });
    const [tableState, setTableState] = useTableState<TableDataType>({
        pagination: {
            show: false,
        },
    });
    const tableData = [
        {
            start: data?.startUtc ?? '',
            closed: data?.endUtc ?? '',
            closer: data?.closer?.name ?? '',
            notes: data?.notes ?? null,
        },
    ] as TableDataType[];

    return (
        <TableProvider columns={tableColumns} state={tableState} onStateChange={setTableState}>
            <Table
                data-test-id="shift-details-table"
                loading={isLoading}
                uniqueRowId="start"
                data={tableData}
                amountOfRows={tableData.length}
            />
        </TableProvider>
    );
};
